/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const VolumeMuteIcon = createIcon({
    displayName: 'VolumeMuteIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M7.015 8.007 10.33 4h1.657s.827 3.636.827 8.007c0 4.357-.83 7.993-.83 7.993H10.33l-3.245-3.993H4.667c-.368 0-.667-.325-.667-.727V8.735c0-.402.299-.728.667-.728h2.348Zm1.104 7.16 2.78 3.42c.236-1.366.582-3.837.582-6.58 0-2.76-.346-5.239-.582-6.604L8.043 8.857l-.4.483h-2.31v5.334h2.386l.4.493ZM18 9.53l.943.943L17.414 12l1.529 1.529-.943.943-1.529-1.529-1.528 1.529L14 13.53l1.529-1.529L14 10.473l.943-.943 1.528 1.529L18 9.53Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M12.22 12.01c0-3.78-.52-7.16-.86-8.99h-.01L7 7.85l-.6.66H2.99v7h3.53l.6.67 4.24 4.78c.35-1.83.86-5.17.86-8.95ZM10.93 1h1.26c.48 0 .88.33.98.79.34 1.63 1.06 5.65 1.06 10.22s-.73 8.57-1.07 10.2c-.1.47-.51.79-.98.79h-1.23c-.29 0-.56-.13-.75-.34l-4.57-5.15H3c-1.1 0-2-.9-2-2v-7c0-1.1.9-2 2-2h2.52l4.67-5.18a1 1 0 0 1 .74-.33Zm10.66 7 1.414 1.414-2.293 2.293L23.004 14l-1.414 1.414-2.293-2.293-2.293 2.293L15.59 14l2.293-2.293-2.293-2.293L17.004 8l2.293 2.293L21.59 8Z",
            clipRule: "evenodd"
        })
    ]
});
VolumeMuteIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'VolumeMuteIcon'
};
export { VolumeMuteIcon };

//# sourceMappingURL=volume-mute.js.map